import * as React from "react";
import ReactDOM from "react-dom";
import "@fontsource/poppins";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { Provider } from "react-redux";

import { App } from "./App";
import { AuthProvider } from "./utils/auth-context";
import theme from "./Theme";
import { reduxStore } from "./store/reduxStore"; // Redux store

import * as serviceWorker from "./serviceWorker";
import reportWebVitals from "./reportWebVitals";

// RTK Query does NOT need QueryClientProvider or queryClient

ReactDOM.render(
  <React.StrictMode>
    <Provider store={reduxStore}>
      <ChakraProvider theme={theme}>
        <ColorModeScript initialColorMode={theme.config.initialColorMode} />
        <AuthProvider>
          <App />
        </AuthProvider>
      </ChakraProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root"),
);

serviceWorker.unregister();
reportWebVitals();
